export const getFriendlyAuthErrorMessage = (error) => {
  if (!error) {
    return 'Login failed. Please try again.';
  }

  const code = typeof error === 'object' ? error.code : undefined;
  const message =
    typeof error === 'string'
      ? error
      : typeof error?.message === 'string'
        ? error.message
        : '';

  // Firebase Auth errors
  switch (code) {
    case 'auth/invalid-credential':
    case 'auth/invalid-login-credentials':
    case 'auth/wrong-password':
    case 'auth/user-not-found':
      return 'Invalid email or password.';
    case 'auth/invalid-email':
      return 'Please enter a valid email address.';
    case 'auth/user-disabled':
      return 'This account is disabled. Please contact support.';
    case 'auth/too-many-requests':
      return 'Too many attempts. Please try again later.';
    case 'auth/network-request-failed':
      return 'Network error. Please check your connection and try again.';
    default:
      break;
  }

  const lower = message.toLowerCase();

  // Backend verification messages (make them non-technical)
  if (lower.includes('email not verified')) {
    return 'Please verify your email before logging in.';
  }
  if (lower.includes('user not verified')) {
    return 'Your account is not yet approved. Please contact an administrator.';
  }
  if (lower.includes('no firestore user document')) {
    return 'Invalid email or password.';
  }
  if (lower.includes('unauthorized role') || lower.includes('unauthorized')) {
    return 'Invalid email or password.';
  }
  if (lower.includes('token verification failed') || lower.includes('invalid token')) {
    return 'Login failed. Please try again.';
  }
  if (lower.includes('firebase admin sdk not initialized')) {
    return 'Service is temporarily unavailable. Please try again later.';
  }
  if (lower.includes('failed to fetch')) {
    return 'Cannot reach the server right now. Please try again.';
  }

  return 'Login failed. Please try again.';
};
